{
  "name": "app-relayter-web",
  "type": "module",
  "version": "2.42.3",
  "license": "MIT",
  "description": "The webapp for Relayter",
  "contributors": [
    {
      "name": "Simon Windt",
      "email": "simon@relayter.com",
      "url": "https://www.relayter.com"
    },
    {
      "name": "Marcel Hoogesteger",
      "email": "marcelhoogesteger@relayter.com",
      "url": "https://www.relayter.com"
    },
    {
      "name": "Tim van Haasteren",
      "email": "timvanhaasteren@relayter.com",
      "url": "https://www.relayter.com"
    }
  ],
  "engines": {
    "node": ">= 24.22"
  },
  "scripts": {
    "start": "ng serve --port 1337 --live-reload false",
    "start-local-api-domain": "ng serve --port 1337 --live-reload false --configuration local-api-domain",
    "start-local-domain": "ng serve --port 1337 --live-reload false --configuration local-api-domain --host 0.0.0.0 --ssl --ssl-cert .ssl/app-development-local.relayter.com.pem --ssl-key .ssl/app-development-local.relayter.com-key.pem",
    "start-dev": "ng serve --port 1337 --configuration dev",
    "build": "ng build --configuration production",
    "build-development": "ng build --progress --configuration dev",
    "build-acceptance": "ng build --progress --configuration accept",
    "build-production": "ng build --progress --configuration production",
    "lint": "ng lint",
    "format": "prettier --write .",
    "format:check": "prettier --check .",
    "version": "echo $npm_package_version",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org relayter --project app-relayter-web ./dist && sentry-cli sourcemaps upload --org relayter --project app-relayter-web ./dist",
    "npm-config": "npm config set //registry.npmjs.org/:_authToken \"${NPM_AUTH_TOKEN}\""
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.0.6",
    "@angular/cdk": "21.0.5",
    "@angular/common": "21.0.6",
    "@angular/compiler": "21.0.6",
    "@angular/compiler-cli": "21.0.6",
    "@angular/core": "21.0.6",
    "@angular/forms": "21.0.6",
    "@angular/localize": "21.0.6",
    "@angular/material": "21.0.5",
    "@angular/platform-browser": "21.0.6",
    "@angular/platform-browser-dynamic": "21.0.6",
    "@angular/router": "21.0.6",
    "@auth0/angular-jwt": "5.2.0",
    "@codemirror/autocomplete": "^6.18.4",
    "@codemirror/commands": "^6.8.0",
    "@codemirror/lang-javascript": "^6.2.2",
    "@codemirror/lang-json": "^6.0.2",
    "@codemirror/lint": "^6.8.4",
    "@codemirror/state": "^6.5.1",
    "@codemirror/theme-one-dark": "^6.1.2",
    "@codemirror/view": "^6.36.2",
    "@relayter/core": "20.0.0",
    "@relayter/rubber-duck": "19.6.4",
    "@rive-app/canvas": "^2.23.8",
    "@sentry/angular": "10.32.1",
    "@sentry/cli": "^2.41.1",
    "chart.js": "^4.5.1",
    "codemirror": "^6.0.1",
    "color": "4.2.3",
    "date-fns": "^4.1.0",
    "date-fns-tz": "^3.2.0",
    "escape-string-regexp": "^5.0.0",
    "eslint-linter-browserify": "^9.18.0",
    "fast-xml-parser": "^5.3.7",
    "filesize": "^11.0.0",
    "globals": "^15.14.0",
    "i18n-iso-countries": "7.12.0",
    "ng-table-virtual-scroll": "^1.6.0",
    "ng2-charts": "8.0.0",
    "ngx-papaparse": "8.0.0",
    "number-to-words": "1.2.4",
    "pixi.js": "8.9.1",
    "rxjs": "7.8.1",
    "socket.io-client": "4.8.3",
    "tslib": "^2.0.0",
    "uuid": "^11.0.2",
    "zone.js": "0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^21.0.4",
    "@angular/cli": "^21.0.4",
    "@segment/analytics-next": "^1.76.0",
    "@types/chart.js": "^2.9.3",
    "@types/color": "^3.0.2",
    "@types/uuid": "3.4.6",
    "angular-eslint": "21.2.0",
    "cerialize": "0.1.18",
    "eslint": "^9.39.2",
    "eslint-plugin-rxjs-x": "^0.7.7",
    "grunt-cli": "^1.5.0",
    "neostandard": "^0.12.2",
    "prettier": "^3.6.2",
    "sass-loader": "14.1.0",
    "ts-node": "8.6.2",
    "typescript": "^5.9.3",
    "typescript-eslint": "8.50.1"
  }
}
